import { render, staticRenderFns } from "./training-media-list.vue?vue&type=template&id=ca460b84&scoped=true&"
import script from "./training-media-list.vue?vue&type=script&lang=js&"
export * from "./training-media-list.vue?vue&type=script&lang=js&"
import style0 from "./training-media-list.vue?vue&type=style&index=0&id=ca460b84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca460b84",
  null
  
)

export default component.exports